import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowsMergeRegular from './arrows-merge-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ArrowsMergeRegular {...props} />;
}
SvgComponent.iconName = 'arrowsMergeRegular';

export const ArrowsMergeRegularIcon = svgIconWrapper(SvgComponent);
